'use client';

import { AD_PLACEMENTS } from './adPlacements';
import { NativeAdSlot } from './NativeAdSlot';

export const HomeFeedNativeAd = () => (
  <NativeAdSlot {...AD_PLACEMENTS.homeFeedNative} />
);
